<template>
  <f7-page
    @page:beforein="beforein"
  >
    <navbar>
      <template
        v-slot:nav-title
        class="breadcrumbs"
      >
        <span
          class="breadcrumb-link"
          @click="$f7.views.main.router.navigate('/cockpit/', { reloadCurrent: true })"
        >
          {{ $t('Home_navbar_title') }}
        </span>
        <f7-icon class="icon-breadcrumb" />
        <span
          class="breadcrumb-link"
          @click="$f7.views.main.router.navigate('/dataBase/', { reloadCurrent: true })"
        >
          {{ $t('LeftPanel_title_bd') }}
        </span>
        <f7-icon class="icon-breadcrumb" />
        <span class="breadcrumb-title">
          {{ $t('IrrigationPage_navbar_title') }}
        </span>
      </template>
    </navbar>
    <div v-if="selection === 'GreenHouse'">
      <IrrigationGreenHouse
        :list-irrigation="listIrrigationGh"
      />
    </div>
    <div v-else>
      <IrrigationOpenAir :list-irrigation="listIrrigationEx" />
    </div>
  </f7-page>
</template>

<script>
import { mapState, mapActions } from 'vuex';
import navbar from '../../components/navbar/NavBar.vue';
import IrrigationGreenHouse from '../../components/irrigation/irrigationGreenHouse/index.vue';
import IrrigationOpenAir from '../../components/irrigation/irrigationOpenAir/index.vue';

export default {
  name: 'DatabaseIrrigation',
  components: {
    navbar,
    IrrigationGreenHouse,
    IrrigationOpenAir,
  },
  computed: {
    ...mapState('authentication', [
      'selection',
    ]),
    ...mapState('Database', [
      'listIrrigationGh', 'listIrrigationEx',
    ]),
  },
  methods: {
    async beforein() {
      this.$f7.preloader.show();
      try {
        await this.fetchListIrrigation();
      } catch (error) {
        const message = this.$helpers.getFilteredErrorMessage(error);
        if (message.includes('default_') && !message.includes('404')) {
          this.$f7.dialog.alert(message.split('_').pop());
        } else if (!message.includes('404')) {
          this.$f7.dialog.alert(this.$t(message));
        }
      } finally {
        this.$f7.preloader.hide();
        this.loaded = true;
      }
    },
    ...mapActions('Database', [
      'fetchListIrrigation',
    ]),
  },
};
</script>
<style lang="scss" scoped>

</style>
